module.exports = __webpack_public_path__ + "static/media/18_4.603dbce4.jpg";